export default {
    getDriverDocuments: (state) => {
        return state.driverDocuments
    },
    getTaxiDocuments: (state) => {
        return state.taxiDocuments
    }
}
